import { token_360_permission } from "./token.permission";

export const survey_permission = {
    required_permission: ['view_survey', 'view_response', 'add_response', 'change_response', 'view_answer', 'view_choice', 'view_group'],
    additional_3cs_permission: ["view_organization"],
    token_survey_permission: token_360_permission.required_permission
}